module.exports = __webpack_public_path__ + "img/bg.79591915.png";